"use strict";

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Subscription = void 0;

var Subscription =
/** @class */
function () {
  function Subscription(defaultMetaData) {
    var _this = this;

    this.setMetaData = function (metaData) {
      _this.metaData = metaData;
    };

    this.getMetaData = function () {
      if (_this.metaData === undefined) {
        throw new Error("meta data not set");
      }

      return _this.metaData;
    };

    this.subscribe = function (fn, label) {
      _this.subscribers = __spreadArrays(_this.subscribers, [{
        fn: fn,
        label: label
      }]);
      return _this.getUnsubscribeFn(fn);
    };

    this.cSubscribers = [];

    this.asyncReverseOrderSubscribe = function (fn, label) {
      _this.cSubscribers.push({
        fn: fn,
        label: label
      });

      if (_this.planned) {
        clearTimeout(_this.planned);
      }

      _this.planned = setTimeout(function () {
        _this.subscribers = __spreadArrays(_this.subscribers, __spreadArrays(_this.cSubscribers).reverse());
        _this.cSubscribers = [];
      }, 0);
      return _this.getUnsubscribeFn(fn);
    };

    this.getUnsubscribeFn = function (fn) {
      return function () {
        _this.subscribers = _this.subscribers.filter(function (e) {
          if (e.isCancelled || e.fn === fn) {
            e.isCancelled = true;
            return false;
          }

          return true;
        });
      };
    };

    this.broadcast = function () {
      var data = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        data[_i] = arguments[_i];
      }

      var arr = _this.subscribers;

      for (var _a = 0, arr_1 = arr; _a < arr_1.length; _a++) {
        var el = arr_1[_a];

        if (el.isCancelled) {
          continue;
        }

        el.fn.apply(el, data);
      }

      _this.subscribers = _this.subscribers.filter(function (e) {
        return !e.isCancelled;
      });
    };

    this.clearSubscribers = function () {
      _this.subscribers = [];
    };

    if (defaultMetaData !== undefined) {
      this.metaData = defaultMetaData;
    }

    this.subscribers = [];
  }

  return Subscription;
}();

exports.Subscription = Subscription;